import React from 'react'

import { makeStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'
import IconTitle from 'components/resource/IconTitle'

import resourceSettings from 'settings/resources'

const {
  resources,
} = resourceSettings

const useStyles = makeStyles(theme => ({
  linkContainer: {
    cursor: 'pointer',
  },
  linkTitle: {
    textDecoration: 'underline',
    color: theme.palette.primary.main,
  },
  folderPathSplitter: {
    marginLeft: theme.spacing(),
    marginRight: theme.spacing(),
  },
}))

const FolderPathTitle = ({
  title,
  section,
  folderPath,
  search,
  onView,
  linkAll,
}) => {
  const classes = useStyles()

  if(!section) throw new Error(`no section given to FolderPathTitle`)

  const resource = resources[section]

  const useFolderPath = [{
    name: `${title ? title + ' ' : ''}${resource.title}`,
    id: 'root',
  }].concat(search ? [{
    name: `search (${search})`,
    id: 'search',
  }] : folderPath)

  const folderPathChunks = useFolderPath.map((pathItem, i) => {

    let showLink = i < useFolderPath.length - 1
    if(pathItem.id == 'search') showLink = false
    if(linkAll) showLink = true
    return (
      <React.Fragment key={ i }>
        <Typography 
          variant="h6"
          className={ showLink ? `${ classes.linkContainer } ${ classes.linkTitle }` : '' }
          onClick={ () => {
            if(!showLink) return
            onView({
              section,
              parentid: pathItem.id,
            })
          }}
        >
          { pathItem.name }
        </Typography>
        {
          i < useFolderPath.length - 1 && (
            <Typography 
              variant="h6"
              className={ classes.folderPathSplitter }
            >
              :
            </Typography>
          )
        }
      </React.Fragment>
      
    )
  })

  return (
    <IconTitle
      type={ section }
    >
      { folderPathChunks }
    </IconTitle>
  )
}

export default FolderPathTitle

